import RetailDashboardLayout from 'src/pages/Dashboard/Layout/RetailDashboardLayout.vue';
import DefaultHeader from 'src/pages/Dashboard/DefaultHeader';
import IframeHeader from 'src/pages/Dashboard/IframeHeader';
import AuthLayout from 'src/pages/Dashboard/Pages/AuthLayout.vue';

// gaa pages
import contract from 'src/pages/Stores/Gaa/Contract.vue';
import Promotions from 'src/pages/Stores/Gaa/Promotions.vue';

// si pages
import retailSiBusiness from 'src/pages/Stores/Retail/si/business.vue';

// retail eaa pages
import retailShops from 'src/pages/Stores/Retail/eaa/shops.vue';
import retailSettings from 'src/pages/Stores/Retail/eaa/settings.vue';
import retailAcls from 'src/pages/Stores/Retail/eaa/acls.vue';
import retailPromotionIndex from 'src/pages/Stores/Retail/eaa/promotions/index.vue';
import retailPromotionSetting from 'src/pages/Stores/Retail/eaa/promotions/settings.vue';

// retail GAA pages
import retailGaaBusiness from 'src/pages/Stores/Retail/business.vue';

// retail common pages
import retailShopInfo from 'src/pages/Stores/Retail/common/info.vue';
import retailShopEdit from 'src/pages/Stores/Retail/common/edit.vue';
import retailShopQRcode from 'src/pages/Stores/Retail/common/qrcode.vue';
import retailShopWizard from 'src/pages/Stores/Retail/common/wizard.vue';

const MenuManagement = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/MenuManagement.vue');

const SiAccounts = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/SiAccounts.vue');
const SiAccount = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/SiAccount.vue');

const EaaAccounts = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/EaaAccounts.vue');
const EaaAccount = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/EaaAccount.vue');
const EaaShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/EaaShops.vue');

const LineNotifyGroups = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/LineNotifyGroups.vue');
// Portals
const Portals = () =>
import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Portals/Portals.vue');

const PortalEdit = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Portals/PortalEdit.vue');

const PortalShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Portals/PortalShops.vue');

const PortalAddShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Portals/PortalAddShops.vue');

const PortalResults = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Portals/PortalResults.vue');

const PortalAllShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Portals/PortalAllShops.vue');

const SendCoupons = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCoupons.vue');

const SendCouponEdit = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCouponEdit.vue');

const SendCouponShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCouponShops.vue');

const SendCouponAddShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCouponAddShops.vue');

const SendCouponResults = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCouponResults.vue');

const SendCouponAllShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCouponAllShops.vue');

const Opening = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/Opening.vue');

const AccountEmail = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/AccountEmail.vue');

const SiEmailTemplate = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/SiEmailTemplate.vue');

const GaaUsers = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/GaaUsers.vue');
const GaaUser = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/GaaUser.vue');

const SiUsers = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/SiUsers.vue');
const SiUser = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/SiUser.vue');

// Components pages
const Buttons = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/Buttons.vue');
const GridSystem = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/GridSystem.vue');
const Panels = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/Panels.vue');
const SweetAlert = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/SweetAlert.vue');
const Notifications = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/Notifications.vue');
const Icons = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/Icons.vue');
const Typography = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/Typography.vue');

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ 'src/pages/Dashboard/Dashboard/Dashboard.vue');

// Maps pages
const GoogleMaps = () =>
  import(/* webpackChunkName: "maps" */ 'src/pages/Dashboard/Maps/GoogleMaps.vue');
const FullScreenMap = () =>
  import(/* webpackChunkName: "maps" */ 'src/pages/Dashboard/Maps/FullScreenMap.vue');
const VectorMaps = () =>
  import(/* webpackChunkName: "maps" */ 'src/pages/Dashboard/Maps/VectorMaps.vue');

// Pages
const User = () =>
  import(/* webpackChunkName: "pages" */ 'src/pages/Dashboard/Pages/UserProfile.vue');
const Pricing = () =>
  import(/* webpackChunkName: "pages" */ 'src/pages/Dashboard/Pages/Pricing.vue');
const TimeLine = () =>
  import(/* webpackChunkName: "pages" */ 'src/pages/Dashboard/Pages/TimeLinePage.vue');
const EaaLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/EaaLogin.vue');
const RetailEaaLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/RetailEaaLogin.vue');
const LineLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/LineLogin.vue');
const SiLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/SiLogin.vue');
const RetailSiLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/RetailSiLogin.vue');
const GaaLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/GaaLogin.vue');
const RetailGaaLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/RetailGaaLogin.vue');
const Register = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/Register.vue');
const Lock = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/Lock.vue');

// Summary & Sales
const Orders = () => import('src/pages/Dashboard/Summary/Orders.vue');
const Stat = () => import('src/pages/Dashboard/Summary/Stat.vue');
const ShopStat = () => import('src/pages/Dashboard/Summary/ShopStat.vue');
const ShopStatPub = () => import('src/pages/Dashboard/Summary/ShopStatPub.vue');
const Sales = () => import('src/pages/Dashboard/Sales/Sales.vue');
const BannedList = () => import('src/pages/Dashboard/Sales/BannedList.vue')

// LoginRecords
const GaaLoginRecords = () => import('src/pages/Dashboard/Login/GaaLoginRecords.vue');
const EaaLoginRecords = () => import('src/pages/Dashboard/Login/EaaLoginRecords.vue');
const SiLoginRecords = () => import('src/pages/Dashboard/Login/SiLoginRecords.vue');

// Printers
const Printers = () => import('src/pages/Dashboard/Printers/Printers.vue');

// QcPos
const Pos = () => import('src/pages/QcPos/Pos.vue');
const PosLogin = () => import('src/pages/QcPos/PosLogin.vue');

// TableList pages
const RegularTables = () =>
  import(/* webpackChunkName: "tables" */ 'src/pages/Dashboard/Tables/RegularTables.vue');
const ExtendedTables = () =>
  import(/* webpackChunkName: "tables" */ 'src/pages/Dashboard/Tables/ExtendedTables.vue');
const PaginatedTables = () =>
  import(/* webpackChunkName: "tables" */ 'src/pages/Dashboard/Tables/PaginatedTables.vue');

let retail_commonPage = {
  path: '/retail/:type/common',
  component: RetailDashboardLayout,
  children: [
    {
      path: ':id/info',
      components: { default: retailShopInfo, header: DefaultHeader },
      // component: info
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: ':id/edit',
      components: { default: retailShopEdit, header: DefaultHeader },
      // component: edit
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: ':id/qr',
      components: { default: retailShopQRcode, header: DefaultHeader },
      // component: qrcode
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: ':id/promotion',
      components: { default: Promotions, header: DefaultHeader },
      // component: qrcode
      meta: { requiresAuth: true }, // 需驗證
    }

  ]
}

let retailGaaPage = {
  path: '/retail/gaa/business',
  component: RetailDashboardLayout,
  children: [{
      path: '',
      components: { default: retailGaaBusiness, header: DefaultHeader },
      // component: business
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'wizard',
      components: { default: retailShopWizard, header: DefaultHeader },
      // component: wizard
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: ':id/contract',
      components: { default: contract, header: DefaultHeader },
      // component: wizard
      meta: { requiresAuth: true }, // 需驗證
    },
  ]
}

let retailSiPage = {
  path: '/retail/si/business',
  component: RetailDashboardLayout,
  children: [{
      path: '',
      components: { default: retailSiBusiness, header: DefaultHeader },
      // component: business
      meta: { requiresAuth: true }, // 需驗證
    }

  ]
}

let retailEaaPage = {
  path: '/retail/eaa/business',
  component: RetailDashboardLayout,
  children: [
    {
      path: 'shop-management',
      components: { default: retailShops, header: DefaultHeader },
      // component: settings
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'promotions',
      components: { default: retailPromotionIndex, header: DefaultHeader },
      // component: settings
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: ':id/promotion-setting',
      components: { default: retailPromotionSetting, header: DefaultHeader },
      // component: settings
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: ':id/settings',
      components: { default: retailSettings, header: DefaultHeader },
      // component: settings
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: ':id/acls',
      components: { default: retailAcls, header: DefaultHeader },
      // component: business
      meta: { requiresAuth: true }, // 需驗證
    },
  ]
}

let retailSummaryMenu = {
  path: '/retail/summary',
  component: RetailDashboardLayout,
  children: [
    {
      path: 'orders',
      name: '訂單列表',
      components: { default: Orders, header: DefaultHeader },
      meta: { requiresAuth: true, retail: true },
    },
    {
      path: 'stat',
      name: '總覽',
      components: { default: Stat, header: DefaultHeader },
      meta: { requiresAuth: true, retail: true },
    },
    {
      path: 'shop-stat',
      name: '單店統計',
      components: { default: ShopStat, header: DefaultHeader },
      meta: { requiresAuth: true, retail: true },
    }
  ]
};

let retailAuthPages = {
  path: '/retail',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: 'eaa-login',
      name: 'Login',
      component: RetailEaaLogin,
      meta: { requiresAuth: false }, // 不需驗證
    },
    {
      path: 'line-login',
      name: 'Login',
      component: LineLogin,
      meta: { requiresAuth: false }, // 不需驗證
    },
    {
      path: 'si-login',
      name: 'Login',
      component: RetailSiLogin,
      meta: { requiresAuth: false }, // 不需驗證
    },
    {
      path: 'gaa-login',
      name: 'Login',
      component: RetailGaaLogin,
      meta: { requiresAuth: false }, // 不需驗證
    },
    // For signing in QC-POS
    {
      path: '/qcpos/login',
      name: 'QC-POS Login',
      component: PosLogin,
      meta: { requiresAuth: false }, // 不需驗證
    }
  ]
};

let retailGeneralPages = {
  path: '/retail',
  component: RetailDashboardLayout,
  children: [
    {
      path: 'menu-management',
      name: 'Menu Management',
      components: { default: MenuManagement, header: IframeHeader },
      // meta: { requiresAuth: true }, // 需驗證
      meta: {
        requiresAuth: true,
        hideContent: true,
        hideFooter: true
      },
    },
    {
      path: 'line-notify-groups',
      name: 'Line Notify Groups Management',
      components: { default: LineNotifyGroups, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'portals',
      name: 'Portals Management',
      components: { default: Portals, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'portals/:portalKey/edit',
      name: 'Portal Detail',
      components: { default: PortalEdit, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'portals/new',
      name: 'New Portals',
      components: { default: PortalEdit, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'portals/shops',
      name: 'All Shops',
      components: { default: PortalAllShops, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'portals/:portalKey/add-shops',
      name: 'All Shops',
      components: { default: PortalAddShops, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'portals/:portalKey/shops',
      name: 'All Shops',
      components: { default: PortalShops, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'portals/:portalKey/shops/:shopId',
      name: 'All Shops',
      components: { default: PortalResults, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'send-coupons',
      name: 'Send Coupons',
      components: { default: SendCoupons, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'send-coupons/:groupId/edit',
      name: 'Send Coupons Detail',
      components: { default: SendCouponEdit, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'send-coupons/new',
      name: 'New Send Coupons Campaign',
      components: { default: SendCouponEdit, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
      {
      path: 'send-coupons/shops',
      name: 'New Send Coupons Campaign',
      components: { default: SendCouponAllShops, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'send-coupons/:groupId/add-shops',
      name: 'New Send Coupons Campaign',
      components: { default: SendCouponAddShops, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'send-coupons/:groupId/vouchers/:voucherId',
      name: 'Send Coupon Campaign Results',
      components: { default: SendCouponResults, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
  
    {
      path: 'send-coupons/:groupId/shops',
      name: 'New Send Coupons Campaign',
      components: { default: SendCouponShops, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'opening',
      name: 'Opening Time Management',
      components: { default: Opening, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'account-email',
      name: 'Send Account Email',
      components: { default: AccountEmail, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'si-email-template',
      name: 'Email Template',
      components: { default: SiEmailTemplate, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'gaa-users',
      name: 'GAA Users',
      components: { default: GaaUsers, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'gaa-users/new',
      name: 'GAA Users',
      components: { default: GaaUser, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'gaa-users/:gaaId/edit',
      name: 'GAA Users',
      components: { default: GaaUser, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'si-accounts',
      name: 'SI Accounts',
      components: { default: SiAccounts, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'si-accounts/new',
      name: 'SI Accounts',
      components: { default: SiAccount, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'eaa-login-record',
      name: 'EAA Login Record',
      components: { default: EaaLoginRecords, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'si-login-record',
      name: 'SI Login Record',
      components: { default: SiLoginRecords, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'gaa-login-Record',
      name: 'ＧAA Login RECORD',
      components: { default: GaaLoginRecords, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'si-users',
      name: 'SI Users',
      components: { default: SiUsers, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'si-users/new',
      name: 'SI Users',
      components: { default: SiUser, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'si-accounts/:siId/si-users/',
      name: 'SI Users',
      components: { default: SiUsers, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'si-accounts/:siId/si-users/new',
      name: 'SI User',
      components: { default: SiUser, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'si-accounts/:siId/si-users/:siUserId/edit',
      name: 'SI User',
      components: { default: SiUser, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'eaa-account',
      name: 'EAA Account',
      components: { default: EaaAccount, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'eaa-accounts',
      name: 'EAA Accounts',
      components: { default: EaaAccounts, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'eaa-accounts/new',
      name: 'EAA Account',
      components: { default: EaaAccount, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'eaa-accounts/:eaaId/edit',
      name: 'EAA Account',
      components: { default: EaaAccount, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    },
    {
      path: 'eaa-accounts/:eaaId/shops',
      name: 'EAA Account',
      components: { default: EaaShops, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    }
  ]
};

let retailSalePages = {
  path: '/retail/sales',
  component: RetailDashboardLayout,
  name: 'Sales',
  redirect: '/sales/query',
  children: [
    {
      path: 'query',
      name: '銷售查詢',
      components: { default: Sales, header: DefaultHeader },
      meta: { requiresAuth: true, retail: true }
    },
    {
      path: 'banned-list',
      name: '封鎖名單',
      components: { default: BannedList, header: DefaultHeader },
      meta: { requiresAuth: true }
    }
  ]
}

let retailPrinterPage = {
  path: '/retail/printers',
  component: RetailDashboardLayout,
  name: 'Printers',
  redirect: '/printers/list',
  children: [
    {
      path: 'list',
      name: '印表機管理',
      components: { default: Printers, header: DefaultHeader },
      meta: { requiresAuth: true }
    }
  ]
};

export {
  retail_commonPage,
  retailGaaPage,
  retailSiPage,
  retailEaaPage,
  retailSummaryMenu,
  retailAuthPages,
  retailGeneralPages,
  retailSalePages,
  retailPrinterPage
};
